import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Modal } from 'antd';
import notification from 'antd/es/notification';
import { configData } from "src/utils/functions/queryFetch"
import { sendCredentials, setData } from './loginWorker';
import { _logout } from 'src/utils/functions/core'

const Login = (props) => {
  const mounted = useRef(true);
  const [isLoading, setIsLoading] = useState()
  const [loginData, setLoginData] = useState()
  const [state, setState] = useState()
  const [termsModalVisible, setTermsModalVisible] = useState(false)
  const pendingLoginRef = useRef(null)
  const navigate = useNavigate();


  // useEffect(() => {
  //   const getData = async () => {
  //     if (mounted.current) {
  //       setIsLoading(true)
  //       const config = await configData(window.location)
  //       if (config) {
  //         console.log(config)
  //         setIsLoading(false)
  //         setState(config)
  //       } else return false
  //     }
  //   }
  //   getData()
  //   // do NOT auto-open Terms modal on mount — modal will be shown after a successful login if needed
  //   return () => { mounted.current = false }
  // }, [])

  const onFinish = async () => {
    // always attempt authentication first, then show Terms modal only when login succeeded and terms are not accepted
    setIsLoading(true)
    const result = await sendCredentials("/api/login", loginData)


    if (!result) {
      setIsLoading(false)
      notification["error"]({
        message: "Error",
        description: "Possible database error - please contact ADMINISTRATOR",
      });
      return
    }

    if (!result?.success) {
      setIsLoading(false)
      notification["error"]({ message: result?.msg ?? "Error" })
      return
    }

    // success: show terms modal if user hasn't accepted yet, otherwise proceed into app
    const accepted = localStorage.getItem("acceptedTerms") === "true"
    if (accepted) {
      const _loading = await setData(result, navigate)
      setIsLoading(_loading)
      return
    }

    // not accepted -> keep successful login result pending and show modal
    pendingLoginRef.current = result
    setTermsModalVisible(true)
    setIsLoading(false)
  };

  const handleTermsAccept = async () => {
    // user accepted terms — persist acceptance and complete login if there is a pending successful auth
    setTermsModalVisible(false)
    setIsLoading(true)
    try { localStorage.setItem("acceptedTerms", "true") } catch (e) { /* ignore */ }

    const pending = pendingLoginRef.current
    pendingLoginRef.current = null
    // console.log(pending)
    if (pending && pending.body) {
      // we already have a successful login result — finalize login using that result
      const _loading = await setData(pending, navigate)
      setIsLoading(_loading)
      return
    }

    // fallback: no pending successful result — try to authenticate now (use current loginData)
    if (!loginData) {
      setIsLoading(false)
      return
    }

    const result = await sendCredentials("/login", loginData)
    if (result?.success) {
      const _loading = await setData(result, navigate)
      setIsLoading(_loading)
    } else {
      setIsLoading(false)
      notification["error"]({ message: result?.msg ?? "Error" })
    }
  };

  const handleTermsCancel = async () => {
    // user declined terms — clear pending login and redirect/logout if an authenticated session was pending
    setTermsModalVisible(false)
    const pending = pendingLoginRef.current
    pendingLoginRef.current = null
    try { localStorage.removeItem("acceptedTerms") } catch (e) { /* ignore */ }
    setIsLoading(false)

    // if there was a successful auth pending (server side session/token may exist), force logout and return to login
    if (pending && pending.body) {
      try {
        // clear frontend state and reload
        _logout(navigate)
      } catch (err) {
        // fallback: just reload
        window.location.reload()
      }
      return
    }

    // otherwise just leave user on the login screen
    notification["warning"]({ message: "Terms not accepted", description: "You must accept terms to continue." })
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      document.getElementById('login').click();
    }
  };

  const origin = window.location.origin
  return (
    <div style={mainDiv}>
      <div style={{ fontSize: 20, fontWeight: "bold", marginBottom: 10, color: "red", textAlign: "center" }}>
        <div>
          The existing application will be phased out and finally shut down by the end of this year.
        </div>
        <div>
          Due to the termination of subdomains.
        </div>
      </div>
      <div style={inputsDiv}>
        <input onKeyDown={handleKeyPress} name="username" type="text" placeholder="Username" onChange={(e) => setLoginData({ ...loginData, username: e.target.value })} style={inputs} />
        <input onKeyDown={handleKeyPress} name="password" type="password" placeholder="Password" onChange={(e) => setLoginData({ ...loginData, password: e.target.value })} style={inputs} />
        <button id="login" onClick={onFinish} style={buttons}>{isLoading ? <>Login <span className="loader" /></> : "Login"}</button>
      </div>

      <Modal
        title="Pogoji uporabe"
        open={termsModalVisible}
        onOk={handleTermsAccept}
        onCancel={handleTermsCancel}
        okText="Sprejmi"
        cancelText="Zavrni"
        width={720}
      >
        <div style={{ maxHeight: 360, overflowY: "auto", marginBottom: 12 }}>
          {state?.loginTerms ? (
            <div dangerouslySetInnerHTML={{ __html: state.loginTerms }} />
          ) : (
            <div>
              {/* cSpell:disable */}
              <p><strong>IZJAVA ZA TESTNO UPORABO APLIKACIJE (verzija 1.9.1 Beta – 01.01.2026)</strong></p>
              <p>Aplikacija je v razvojni oziroma testni fazi in ni namenjena obdelavi dejanskih osebnih podatkov.
                V tej fazi aplikacija ne zagotavlja popolne varnosti podatkov.</p>
              <p>Uporabnik se strinja, da:</p>
              <ul>
                <li>aplikacijo uporablja izključno na lastno odgovornost,</li>
                <li>v aplikacijo ne vnaša dejanskih osebnih podatkov, razen če je to izrecno dogovorjeno,</li>
                <li>je sam odgovoren za vse podatke, ki jih vnese v aplikacijo,</li>
                <li>razvijalec aplikacije ne odgovarja za izgubo, spremembo ali razkritje podatkov, ki nastanejo zaradi testne uporabe,</li>
                <li>lahko razvijalec kadarkoli izbriše vse testne podatke brez predhodnega obvestila.</li>
              </ul>
              <p>Z uporabo aplikacije uporabnik potrjuje, da se z navedenim strinja.</p>
              <p><a href="https://terms.linijart.eu/">Več o pogojih testne uporabe</a></p>
              {/* cSpell:enable */}
            </div>
          )}
        </div>
      </Modal>
    </div>
  )
}
const imageStyle = {
  height: 118,
  marginBottom: 10
}
const mainDiv = {
  marginTop: 30,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "",
  flexDirection: "column"
}
const inputsDiv = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "10px",
  padding: "20px",
  border: "1px solid #ccc", borderRadius: "",
  boxShadow: "0px 4px 6px rgba(0,0,0,0.1)"
}
const inputs = {
  padding: "5px",
  width: "250px",
  borderRadius: "",
  border: "1px solid #ccc"
}
const buttons = {
  padding: "5px 20px",
  borderRadius: "",
  border: "none",
  backgroundColor: "",
  color: "",
  cursor: "pointer",
  border: "1px solid #ccc",
  minWidth: 100
}
export default Login;
